var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.5999C7.913 4.5999 4.5999 7.913 4.5999 11.9999C4.5999 16.0868 7.913 19.3999 11.9999 19.3999C16.0868 19.3999 19.3999 16.0868 19.3999 11.9999C19.3999 7.913 16.0868 4.5999 11.9999 4.5999ZM3.3999 11.9999C3.3999 7.25025 7.25025 3.3999 11.9999 3.3999C16.7496 3.3999 20.5999 7.25025 20.5999 11.9999C20.5999 16.7496 16.7496 20.5999 11.9999 20.5999C7.25025 20.5999 3.3999 16.7496 3.3999 11.9999Z",
    fill: "#667C99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6.54272C12.3313 6.54272 12.5999 6.81135 12.5999 7.14272V11.7512L15.8551 15.004C16.0895 15.2382 16.0897 15.6181 15.8554 15.8525C15.6212 16.0869 15.2413 16.0871 15.0069 15.8529L11.3999 12.2485V7.14272C11.3999 6.81135 11.6685 6.54272 11.9999 6.54272Z",
    fill: "#667C99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.54383b4b1f7bc1a548968dcd8ce1b720.svg";
export { ForwardRef as ReactComponent };